<template>
  <div class="gallery">
    <section class="page-hero">
      <div class="container">
        <span class="eyebrow eyebrow-light">{{ $t('gallery.hero.eyebrow') }}</span>
        <h1>{{ $t('gallery.hero.title') }}</h1>
        <p>{{ $t('gallery.hero.subtitle') }}</p>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="image-grid">
          <div class="slider-card card" v-for="(s, i) in sliders" :key="s.key">
            <div class="slider">
              <div class="slides" :style="{ transform: `translateX(-${current[i] * 100}%)` }">
                <img v-for="(src, j) in s.images" :key="j" :src="src" :alt="$t(`gallery.${s.key}.title`)" loading="lazy" />
              </div>
            </div>
            <h3>{{ $t(`gallery.${s.key}.title`) }}</h3>
            <p>{{ $t(`gallery.${s.key}.caption`) }}</p>
          </div>
        </div>
        <p class="note">{{ $t('gallery.note') }}</p>
      </div>
    </section>
  </div>
</template>

<script>
const BASE = 'https://sdapipublic.s3.ca-central-1.amazonaws.com';

export default {
  name: 'PhotoGallery',
  data() {
    return {
      sliders: [
        {
          key: 'women',
          images: [
            `${BASE}/image+(5).png`,
            `${BASE}/image+(9).jpg`,
            `${BASE}/image+(10).jpg`,
            `${BASE}/image+(11).jpg`,
          ],
        },
        {
          key: 'tree',
          images: [
            `${BASE}/hindkrantisena/image+(13).jpg`,
            `${BASE}/hindkrantisena/image+(14).jpg`,
            `${BASE}/hindkrantisena/image+(15).jpg`,
          ],
        },
        {
          key: 'animal',
          images: [
            `${BASE}/hindkrantisena/image+(16).jpg`,
            `${BASE}/hindkrantisena/image+(17).jpg`,
            `${BASE}/hindkrantisena/image+(18).jpg`,
            `${BASE}/hindkrantisena/image+(19).jpg`,
          ],
        },
        {
          key: 'clean',
          images: [
            `${BASE}/hindkrantisena/image+(20).jpg`,
            `${BASE}/hindkrantisena/image+(21).jpg`,
            `${BASE}/hindkrantisena/image+(22).jpg`,
            `${BASE}/hindkrantisena/image+(23).jpg`,
          ],
        },
      ],
      current: [0, 0, 0, 0],
      timers: [],
    };
  },
  mounted() {
    this.sliders.forEach((s, i) => {
      this.timers.push(setInterval(() => {
        this.current[i] = (this.current[i] + 1) % s.images.length;
      }, 3500));
    });
  },
  beforeUnmount() {
    this.timers.forEach(clearInterval);
  },
};
</script>

<style scoped>
.page-hero { background: linear-gradient(135deg, var(--charcoal-dark), var(--charcoal)); color: #fff; padding: 76px 0; text-align: center; }
.eyebrow-light { color: #8FDDD8; text-transform: uppercase; letter-spacing: 1.5px; font-weight: 700; font-size: 0.8rem; }
.page-hero h1 { font-size: clamp(1.7rem, 3.4vw, 2.3rem); margin: 12px 0 10px; }
.page-hero p { color: rgba(255,255,255,0.88); margin: 0; }

.image-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 26px; }
.slider-card h3 { margin: 14px 0 4px; color: var(--charcoal); font-size: 1.05rem; }
.slider-card p { color: var(--muted); font-size: 0.9rem; margin: 0; }
.slider { overflow: hidden; border-radius: 10px; position: relative; background: var(--charcoal-tint); aspect-ratio: 4 / 3; }
.slides { display: flex; height: 100%; transition: transform 0.8s ease-in-out; }
.slides img { min-width: 100%; height: 100%; object-fit: cover; }

.note { text-align: center; color: var(--muted); margin-top: 30px; font-size: 0.92rem; }
</style>
